import { render, staticRenderFns } from "./Typeoperations.vue?vue&type=template&id=7f2ffe8d&"
import script from "./Typeoperations.vue?vue&type=script&lang=js&"
export * from "./Typeoperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports